import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import history from 'srcReact/helpers/history'
import Avatar from 'srcReact/components/common2/Avatar'
import SideBarMainMobile from 'srcReact/components/common2/Navigation/SideBarMain/components/SideBarMainMobile'
import styles from './styles.module.scss'
import IconButton from '../../IconButton'
import AnchorLink from '../../AnchorLink'

export default function SideBarMain() {
  const { t } = useTranslation()
  const location = history.location.pathname
  const {
    login: { user },
    common: { isMobile, isTablet, isNative },
    organization: { current_organization }
  } = useSelector((state) => state)

  const { sidebar } = useSelector((state) => {
    if (state.organization && state.organization.header) {
      return state.organization.header
    }
    return {}
  })

  const feedActive = location.match(/feed/) ? true : false
  const homeActive = location.match(/myhome/) ? true : false
  const discoverActive = location.match(/discover/) ? true : false
  const dashboardActive = location.match(/dashboard\/workplace/) ? true : false
  const calendarActive = location.match(/calendar/) ? true : false
  const mixrHomeActive = location.match(/home\/event/) ? true : false
  const groupHomeActive = location.match(/home\/group/) ? true : false

  const getDashboardLink = (data) => {
    const { workplace_id, group_id } = data
    if (workplace_id && workplace_id > 0) {
      return `/0/dashboard/workplace/${workplace_id}`
    } else if (group_id && group_id > 0) {
      return `/0/dashboard/group/${group_id}`
    }
  }

  const hasCurrentOrganization = () => {
    return current_organization && current_organization.info && current_organization.info.id > 0
  }

  return (isMobile && !isNative) ||
    (isTablet && !isNative) ||
    (groupHomeActive && isNative) ||
    (mixrHomeActive && isNative) ? (
    <SideBarMainMobile
      feedActive={feedActive}
      homeActive={homeActive}
      discoverActive={discoverActive}
      calendarActive={calendarActive}
      mixrHomeActive={mixrHomeActive}
      groupHomeActive={groupHomeActive}
      isNative={isNative}
      currentOrganization={hasCurrentOrganization() ? current_organization : null}
    />
  ) : !isMobile && !isTablet && !isNative ? (
    <aside className={`${styles.sideBarWrapper}`} aria-label={t('nav.sidemenu')} id='mixr-side-section'>
      <div className={`${styles.topOuterWrapper}`}>
        <div className={styles.settingsContainer}>
          <IconButton
            iconName='setting'
            iconSize='large24'
            className={styles.settingButton}
            onClick={() => history.push('/0/settings/account')}
            aria-label={t('account_settings.sidebar.first_main_nav')}
          />
        </div>
        <div className={`${styles.imageWrapper}`}>
          <Avatar
            userId={user.id}
            firstname={user.firstname}
            lastname={user.lastname}
            profilePicture={user.profile_picture}
            rounded
            mimeType={user.mime_type}
            originalTag={user.original_tag}
            isOriginal={user.is_original}
            ariaLabel={t('nav.profile')}
            onClickAction={() => history.push(`/0/profile/${user.id}`)}
          />
        </div>
      </div>
      <div className={`${styles.navLinkWrapper}`}>
        <AnchorLink
          id='onboarding_myhome'
          aria-label={t('sidebar.home')}
          path='/0/myhome'
          className={`${styles.linkWrapper} ${homeActive ? styles.active : ''}`}>
          <img width='24' height='24' src={`${config.assetUrl + '/images/myHome-colored.svg'}`} alt='' />
          <h2 className={`${styles.label} ${homeActive && styles.activeLabel}`}>{t('sidebar.home')}</h2>
        </AnchorLink>

        <AnchorLink
          id='onboarding_feed'
          aria-label={t('sidebar.feed')}
          className={`${styles.linkWrapper} ${feedActive ? styles.active : ''}`}
          path='/0/feed'>
          <img width='24' height='24' src={`${config.assetUrl + '/images/feed-icon.svg'}`} alt='' />
          <h2 className={`${styles.label} ${feedActive && styles.activeLabel}`}>{t('sidebar.feed')}</h2>
        </AnchorLink>
        <AnchorLink
          id='onboarding_discover'
          aria-label={t('sidebar.discover')}
          className={`${styles.linkWrapper} ${discoverActive ? styles.active : ''}`}
          path='/0/discover'>
          <img width='24' height='24' src={`${config.assetUrl + '/images/discover-coloured.svg'}`} alt='' />
          <h2 className={`${styles.label} ${discoverActive && styles.activeLabel}`}>{t('sidebar.discover')}</h2>
        </AnchorLink>
        {sidebar?.dashboard && (sidebar.dashboard.group_id > 0 || sidebar.dashboard.workplace_id > 0) && (
          <AnchorLink
            id='onboarding_dashboard'
            aria-label={t('sidebar.dashboards')}
            className={`${styles.linkWrapper} ${dashboardActive ? styles.active : ''}`}
            path={getDashboardLink(sidebar.dashboard)}>
            <img width='24' height='24' src={`${config.assetUrl + '/images/dashboards-icon.svg'}`} alt='' />
            <h2 className={`${styles.label} ${dashboardActive && styles.activeLabelDashboard}`}>
              {t('sidebar.dashboards')}
            </h2>
          </AnchorLink>
        )}
        <AnchorLink
          id='onboarding_calendar'
          aria-label={t('sidebar.calendar')}
          className={`${styles.linkWrapper} ${calendarActive ? styles.active : ''}`}
          path='/0/calendar'>
          <img width='24' height='24' src={`${config.assetUrl + '/images/calendar-colored.svg'}`} alt='' />
          <h2 className={`${styles.label} ${calendarActive && styles.activeLabel}`}>{t('sidebar.calendar')}</h2>
        </AnchorLink>
      </div>
    </aside>
  ) : null
}
